import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { WhatsappLogo, Phone, X, Plus } from "@phosphor-icons/react";

const WHATSAPP_URL = "https://wa.me/33745709881?text=Bonjour%20Pixora%20%21%20J%27aimerais%20avoir%20des%20informations%20sur%20vos%20formules%20photobooth.";
const PHONE_URL = "tel:+33745709881";

export default function FloatingContact() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3" data-testid="floating-contact">
      <AnimatePresence>
        {open && (
          <>
            <motion.a
              key="whatsapp"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Contacter Pixora sur WhatsApp"
              data-testid="floating-whatsapp"
              initial={{ opacity: 0, y: 20, scale: 0.6 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.6 }}
              transition={{ duration: 0.22, delay: 0.05 }}
              className="group flex items-center gap-3 pl-4 pr-2 py-2 bg-[#25D366] hover:bg-[#1ebe57] rounded-full shadow-[0_8px_24px_rgba(37,211,102,0.45)] transition-colors"
            >
              <span className="text-white text-sm font-medium tracking-wide">WhatsApp</span>
              <span className="w-11 h-11 flex items-center justify-center rounded-full bg-white/15">
                <WhatsappLogo size={24} weight="fill" className="text-white" />
              </span>
            </motion.a>

            <motion.a
              key="phone"
              href={PHONE_URL}
              aria-label="Appeler Pixora"
              data-testid="floating-phone"
              initial={{ opacity: 0, y: 20, scale: 0.6 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.6 }}
              transition={{ duration: 0.22 }}
              className="group flex items-center gap-3 pl-4 pr-2 py-2 bg-[#0b0b0b] hover:bg-[#1a1a1a] border border-[#C9A962] rounded-full shadow-[0_8px_24px_rgba(201,169,98,0.35)] transition-colors"
            >
              <span className="text-[#F5E6B8] text-sm font-medium tracking-wide">07 45 70 98 81</span>
              <span className="w-11 h-11 flex items-center justify-center rounded-full bg-[#C9A962]">
                <Phone size={22} weight="fill" className="text-[#0b0b0b]" />
              </span>
            </motion.a>
          </>
        )}
      </AnimatePresence>

      <motion.button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Fermer le menu de contact" : "Ouvrir le menu de contact"}
        aria-expanded={open}
        data-testid="floating-toggle"
        whileTap={{ scale: 0.92 }}
        className={`relative w-14 h-14 rounded-full flex items-center justify-center shadow-[0_10px_28px_rgba(201,169,98,0.5)] transition-all ${
          open
            ? "bg-[#0b0b0b] border-2 border-[#C9A962]"
            : "bg-gradient-to-br from-[#E6C97A] to-[#C9A962] hover:from-[#F0D68A] hover:to-[#D4B570]"
        }`}
      >
        <span className="absolute inset-0 rounded-full bg-[#C9A962]/40 animate-ping" style={{ animationDuration: "2.4s", opacity: open ? 0 : 1 }} />
        <AnimatePresence mode="wait" initial={false}>
          {open ? (
            <motion.span
              key="close"
              initial={{ rotate: -90, opacity: 0 }}
              animate={{ rotate: 0, opacity: 1 }}
              exit={{ rotate: 90, opacity: 0 }}
              transition={{ duration: 0.18 }}
              className="relative"
            >
              <X size={24} weight="bold" className="text-[#C9A962]" />
            </motion.span>
          ) : (
            <motion.span
              key="open"
              initial={{ rotate: 90, opacity: 0 }}
              animate={{ rotate: 0, opacity: 1 }}
              exit={{ rotate: -90, opacity: 0 }}
              transition={{ duration: 0.18 }}
              className="relative"
            >
              <Plus size={26} weight="bold" className="text-[#0b0b0b]" />
            </motion.span>
          )}
        </AnimatePresence>
      </motion.button>
    </div>
  );
}
